import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/auth";
import { LanguageProvider } from "@/i18n";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Families from "@/pages/Families";
import FamilyDetail from "@/pages/FamilyDetail";
import FamilyForm from "@/pages/FamilyForm";
import Reports from "@/pages/Reports";
import AdminUsers from "@/pages/AdminUsers";

function RequireAccess({ children, adminOnly = false }) {
  const { user, demoMode, checking } = useAuth();
  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-10 w-10 rounded-full border-2 border-brand-red border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!demoMode && !user) return <Navigate to="/login" replace />;
  if (adminOnly && (!user || user.role !== "admin" || demoMode)) return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <RequireAccess>
            <Layout />
          </RequireAccess>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/families" element={<Families />} />
        <Route path="/families/new" element={<FamilyForm />} />
        <Route path="/families/:familyId" element={<FamilyDetail />} />
        <Route path="/families/:familyId/edit" element={<FamilyForm />} />
        <Route path="/reports" element={<Reports />} />
        <Route
          path="/admin/users"
          element={
            <RequireAccess adminOnly>
              <AdminUsers />
            </RequireAccess>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
